import { EnumSchema, PolicyType } from '@40seas/entities/common';
import { z } from 'zod';
import { UnderwritingResultStatus } from './underwriting.result.status.enum';

export const UnderwritingResultSchema = z
    .object({
        status: EnumSchema(UnderwritingResultStatus),
        creditLimit: z.number().gt(0, 'Credit limit must be greater than $0').optional(),
        decisionType: EnumSchema(PolicyType).optional(),
    })
    .strict();

export class UnderwritingResult {
    status: UnderwritingResultStatus;
    creditLimit?: number;
    decisionType?: PolicyType;
}
